import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './users.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import { UserType } from '@/types/users.types';

@WithRender
@Component({
  filters:{
    formateDate(value: string)
    {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
  },
})
export default class Users extends Vue {
  username = "";
  exact = "";
  userDetails = {} as UserType;
  
  items = [];
  fields = [
    {
      key: "userName",
    },
    {
      key: "agentCode",
    },
    {
      key: "fullName",
    },
    {
      key: "email",
    },
    {
      key: "whatsApp",
    },
    {
      key: "balance",
    },
    {
      key: "creditBalance",
    },
    {
      key: "createdOn",
      label: "Time",
    },
    {
      key: "id",
      label:""
    }
  ]


   onSearch() {
    _axios
      .get(
          `${config.gateway}admin/User?username=${this.username}&exactSearch=${this.exact}`
      )
      .then((response) => {
        this.items = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
